import { AppSharedModule } from '../../../_shared/app-shared.module';
import { RouterModule } from '@angular/router';
import { MenuComponent } from './menu.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuIconComponent } from './menu-icon/menu-icon.component';
import {
  PerfectScrollbarModule,
  PerfectScrollbarConfigInterface,
  PERFECT_SCROLLBAR_CONFIG
} from 'ngx-perfect-scrollbar';
import { SharedModule } from 'src/app/_theme/components/shared.module';
// import { TranslationShared } from 'src/app/_shared/translation/translation-shared.module';
import { TranslateModule } from '@ngx-translate/core';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [MenuComponent, MenuIconComponent],
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    RouterModule,
    SharedModule,
    // TranslationShared,
    TranslateModule,
    AppSharedModule
  ],
  exports: [
    MenuComponent, MenuIconComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class MenuModule { }
